<template>
	<UiRow align="center" gap="1">
      <img src="/img/icons/dollar.png" style="height: 24px;">
      {{ $store.state.dashboard.balance ? $store.state.dashboard.balance.balance : '0' }}
    </UiRow>
</template>